export const ArrowRight = ({className}) => (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" xmlSpace="preserve" viewBox="0 0 21.8 15.6">
    <path className="fill-primary" d="M21.8 7.8c0-.1 0-.2-.1-.3 0-.1-.1-.2-.2-.2L14.4.2c-.3-.3-.7-.3-1 0s-.3.7 0 1l5.9 5.9H.7c-.4 0-.7.3-.7.7s.3.7.7.7h18.7l-5.9 5.9c-.3.3-.3.7 0 1 .1.1.3.2.5.2s.4-.1.5-.2l7.1-7.1.2-.2v-.3z" />
    </svg>
);